export const getPeopleCardRoute =
    (baseGetCurrentRoute: () => string[], moduleBasePath: string) => () => {
        // baseGetCurrentRoute is called always to make sure mobx store changes are always monitored
        let route = baseGetCurrentRoute();

        // Just return existing route when we are already in people card route
        if (window.location.pathname.indexOf('/card/') > -1) {
            route = window.location.pathname
                .replace(moduleBasePath, '')
                .split('/')
                .map(decodeURIComponent);
        }

        return route;
    };
